import { render, staticRenderFns } from "./YourCourse.vue?vue&type=template&id=0223531e&scoped=true&"
import script from "./YourCourse.vue?vue&type=script&lang=js&"
export * from "./YourCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223531e",
  null
  
)

export default component.exports